import { useImportContactsForExternalAddress } from '@Hooks/Stammdaten/useImportContactsForExternalAddress';
import { ImportableErpContactsModal } from './ImportableErpContactsModal';

interface ImportExternalErpContactsFlowProps {
    isOpen: boolean;
    onClose: () => void;
    externalAddressId: string;
    onImported: () => void;
}

export function ImportExternalErpContactsFlow({
    isOpen,
    onClose,
    externalAddressId,
    onImported,
}: ImportExternalErpContactsFlowProps) {
    const { loadContacts, isImporting, importAsync } = useImportContactsForExternalAddress(externalAddressId);

    const handleImport = async (selectedContactIds: string[]) => {
        await importAsync({ external_contact_person_ids: selectedContactIds });
        onImported();
        onClose();
    };

    return (
        <ImportableErpContactsModal
            isOpen={isOpen}
            onClose={onClose}
            title="Ansprechpartner aus ERP importieren"
            loadContacts={loadContacts}
            isImporting={isImporting}
            handleImport={handleImport}
        />
    );
}
